<template>
    <div class="l-banner" :class="type"  @click='jump' :style='winH' >
        <div class="msg _container">
            <h1 class="title">
                {{ title }}
            </h1>
            <h4 class="sub-title">
                {{ subTitle }}
            </h4>
            <p class="slogan">
                {{ slogan }}
            </p>
        </div>
        <l-img :src='src' type='full' />
    </div>
</template>

<script>


export default {
    name: 'l-banner',
    props: {
        type: {
            default: ''
        },
        src:{
            default: ''
        },
        path: {
            default: ''
        },
        title:{
            default: ''
        },
        subTitle:{
            default: ''   
        },
        slogan: {
            default: ''
        }
    },
    data(){
        return {}
    },
    computed: {
        winH(){
            return { 'height': `${document.body.clientHeight}px` }
        }
    },

    methods: {
        jump(){
            this.path&&this.$router.push(this.path)
        }
    }

}
</script>
<style lang="scss" scoped>
.l-banner{
    position: relative;
    box-sizing: border-box;
    height: 100%;
}

.l-banner.center{
    .msg{
        text-align: center;
    }
}

.msg{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    margin: auto;
    height: 248px;  
    z-index: 9;
    color: $font_color_light;

    .title{
        margin-bottom: 22px;
        font-size: $font_size_banner_title;
    }
    
    .sub-title{
        font-weight: 300;
        font-size: $font_size_banner_sub_title;
    }

    .slogan{
        margin-top: 102px;
        font-size: $font_size_banner_slogan;
        font-weight: 300;
    }
}

</style>